import type { MenuDataItem } from '@wix/thunderbolt-components-native';
import { reportError } from '../../../reporters';
import { InvalidIdPatternError, NonUniqueIdError } from '../errors';
import { isString } from '../../../assert';

const idPattern = /^[a-zA-Z\d-]*$/;

const validateIdPattern = (
  items?: Array<MenuDataItem>,
  parentIndex?: number,
) => {
  items?.every(({ id, link = '', label = link, menuItems }, index) => {
    if (id && !idPattern.test(id)) {
      throw new InvalidIdPatternError({
        index: parentIndex === undefined ? index : parentIndex,
        label,
        id,
      });
    }

    return validateIdPattern(menuItems, index);
  });
};

const validateIdUniqueness = (items?: Array<MenuDataItem>) => {
  const ids = getItemIds(items || []);
  const duplicatedId = findDuplicate(ids);
  if (duplicatedId !== undefined) {
    throw new NonUniqueIdError({ id: duplicatedId });
  }
};

const getItemIds = (menuItems: Array<MenuDataItem>) => {
  return menuItems.reduce<Array<string>>(
    (agg: Array<string>, curr): Array<string> => {
      return [
        ...agg,
        ...(isString(curr.id) ? [curr.id] : []),
        ...(curr.menuItems ? getItemIds(curr.menuItems) : []),
      ];
    },
    [],
  );
};

const findDuplicate = (arr: Array<string>) => {
  return arr.find((value, idx) => {
    return idx !== arr.lastIndexOf(value);
  });
};

export const validateMenuItemsId = (
  menuItems?: Array<MenuDataItem>,
): boolean => {
  try {
    validateIdUniqueness(menuItems);
    validateIdPattern(menuItems);
  } catch (error: any) {
    reportError(error.message);
    return false;
  }

  return true;
};
